import { toast } from 'react-hot-toast';

// Centralized Activity Level Config
export const ACTIVITY_LEVELS = [
  { level: 0, min: 0, max: 0, label: '0 files', color: '#777777' },
  { level: 1, min: 1, max: 1, label: '1 file', color: '#9be9a8' },
  { level: 2, min: 2, max: 3, label: '2-3 files', color: '#40c463' },
  { level: 3, min: 4, max: 5, label: '4-5 files', color: '#01ca36' },
  { level: 4, min: 6, max: Infinity, label: '6+ files', color: '#00ff00' },
];

// #01ca36

export const brandColors = {
    "skyBlue": "#7EC8E3",     // softer retro blue (think vintage posters)
    "mintGreen": "#A7E3B8",   // lighter, pastel-leaning green
    "coralRed": "#FF6F61",    // classic retro coral (warmer than neon red)
    "lavender": "#B9A6F7",    // vintage purple with soft pastel touch
    "sunsetOrange": "#FF8C42",// retro punchy orange (muted enough for modern use)
    "amberYellow": "#FFC857", // golden retro yellow (less harsh than pure #ffa500)
    "sand": "#D9C5A0",        // warm beige/earth retro tone
    "charcoal": "#353535"     // deeper modern neutral black
  }
  

export const brandColorsTwo = {
    "coral": "#FF6B6B",
    "mint": "#4ECDC4",
    "lavender": "#A78BFA",
    "sunshine": "#FFD93D",
    "azure": "#6C63FF",
    "rose": "#FF8FAB",
    "forest": "#2ECC71"
}

export const fileStatusColors = {
  "original": "#00BFFF",      // Electric Blue
  "uploaded": "#00BFFF",      // Electric Blue
  "pending": "#FFA500",    // Amber Orange    // Tomato Red
  "audited": "rgb(100 242 168)",       // Deep Pink
  "repriced": "#9370DB",      // Medium Purple
  "verified": "#00FF99"       // Electric Subtle Green
}

// switch (props.status) {
//     case 'completed':
//       return '#10b981';
//     case 'uploaded':
//       return '#3b82f6';
//     case 'pending':
//       return '#f59e0b';
//     case 'failed':
//       return '#ef4444';
//     default:
//       return '#6b7280';
//   }

export const getStatusColor = (status) => {
  return fileStatusColors[status] || '#B3B3B3';
}


export const medicareJurisdictions = {
    "JF":{
        type: "Noridian",
        color: "#ed9cdc",
        states: [
            "Washington",
            "Oregon",
            "Idaho",
            "Montana",
            "Wyoming",
            "North Dakota",
            "South Dakota",
            "Utah",
            "Arizona",
            "Alaska"
        ]
    },
    "JE":{
        type: "Noridian",
        color: "#002dbf",
        states: [
            "California",
            "Nevada",
            "Hawaii"
        ]
    },
    "JH":{
        type:"Novitas",
        color: "#0094c2",
        states: [
            "Colorado",
            "New Mexico",
            "Oklahoma",
            "Texas",
            "Arkansas",
            "Louisiana",
            "Mississippi",
        ]
    },
    "J5":{
        type: "WPS",
        color: "#ffb02c",
        states: [
            "Kansas",
            "Nebraska",
            "Iowa",
            "Missouri",
        ]
    },
    "J6":{
        type: "NGS",
        color: "#7e2f12",
        states: [
            "Minnesota",
            "Wisconsin",
            "Illinois",
        ]
    },
    "J8":{
        type: "WPS",
        color: "#00a650",
        states: [
            "Michigan",
            "Indiana",
        ]
            
    },
    "J15":{
        type: "CGS",
        color: "#00ffff",
        states: [
            "Ohio",
            "Kentucky",
        ]
    },
    "JK":{
        type: "NGS",
        color: "#f07123",
        states: [
            "Maine",
            "Vermont",
            "New Hampshire",
            "Massachusetts",
            "Connecticut",
            "Rhode Island",
            "New York",
        ]
    },
    "JL":{
        type: "Novitas",
        color: "#c566f8",
        states: [
            "New Jersey",
            "Pennsylvania",
            "Delaware",
            "Maryland",
        ]
            
    },
    "JM":{
        type: "Palmetto",
        color: "#88fd98",
        states: [
            "West Virginia",
            "Virginia",
            "North Carolina",
            "South Carolina",
        ]
    },
    "JJ":{
        type: "Palmetto",
        color: "#ff548b",
        states: [
            "Tennessee",
            "Alabama",
            "Georgia",
        ]
    },
    "JN":{
        type: "FCSO",
        color: "#0070aa",
        states: [
            "Florida",
            "Puerto Rico",
            "U.S. Virgin Islands",
        ]
    }       
}


export const toastConfig = {
    position: 'bottom-center',
    duration: 4000,
    style: {
        background: 'var(--bg-panel)',
        color: 'var(--text-primary)',
        borderRadius: '8px',
        padding: '16px',
        fontSize: '14px',
        fontFamily: '"Space Grotesk", sans-serif',
        border: '1px solid var(--border-color)',
    },
    // Styling
    className: '',
    // containerStyle: {
    //     position: 'absolute',
    //     top: '50%',
    //     left: '50%',
    //     transform: 'translate(-50%, -50%)',
    // },
  
    // Custom Icon
    // icon: '👏',
  
    // Change colors of success/error/loading icon
    iconTheme: {
      primary: '#000',
      secondary: '#fff',
    },
  
    // Aria
    ariaProps: {
      role: 'status',
      'aria-live': 'polite',
    },
  
    // Additional Configuration
    removeDelay: 1000,
}

export const successToastConfig = {
    ...toastConfig,
    style: {
        ...toastConfig.style,
        background: '#45a328ff',
        color: '#fff',
    },
    iconTheme: {
        primary: '#fff',
        secondary: 'var(--color-green)',
    },
}

export const dangerToastConfig = {
    ...toastConfig,
    style: {
        ...toastConfig.style,
        background: '#ff2962ff',
        color: '#ffffffff',
    },
    iconTheme: {
        primary: '#fff',
        secondary: 'var(--color-red)',
    },
}

// Custom toast with close button
export const customToastConfig = {
    ...toastConfig,
    style: {
        ...toastConfig.style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: '300px',
    },
}

// Helper function to create custom toast with close button
export const createCustomToast = (message, theme = 'dark') => {
    return toast.custom(
        (t) => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: theme === 'dark' ? '#333' : '#fff',
                color: theme === 'dark' ? '#fff' : '#333',
                borderRadius: '8px',
                padding: '16px',
                fontSize: '14px',
                fontFamily: '"Space Grotesk", sans-serif',
                border: theme === 'dark' ? '1px solid #555' : '1px solid #ddd',
                minWidth: '300px',
            }}>
                <span>{message}</span>
                <button
                    onClick={() => toast.dismiss(t.id)}
                    className={`close-button-circle ${theme}`}
                    style={{
                        marginLeft: '12px',
                        background: theme === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        padding: '0',
                        transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = theme === 'dark' ? 'rgba(255, 255, 255, 0.16)' : 'rgba(0, 0, 0, 0.16)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = theme === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)';
                    }}
                    aria-label="Close toast"
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>
        ),
        {
            duration: 4000,
            position: 'bottom-center',
        }
    );
};